const initialAppFilterState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0,
};


export const getUserCardListReducer = (state = initialAppFilterState, action) => {
  switch (action.type) {

    case "GET_USER_CARD_LIST_PENDING": {
      return {...state, fetched: false, fetching: true};
    }
    case "GET_USER_CARD_LIST_FULFILLED": {
      const {data, nbResult} = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data ? data : [],
        nbResult: nbResult
      };
    }

    case "GET_USER_CARD_LIST_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        nbResult: 0,
        error
      };
    }

    case 'DEACTIVATE_CARD': {
      return {
        ...state,
        items: state.items.filter(item => item.Id != action.payload)
      };
    }

    case 'DELETE_CARD': {
      return {
        ...state,
        items: state.items.filter(item => item.cardDetails.Id != action.payload)
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/MangoPay/getUserCardListReducer.js